module.exports = __webpack_public_path__ + "img/vuelo1.36070986.jpg";